import styled from '@emotion/styled'

export const V2L2ModalActionbar = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	gap: '0.5rem',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: theme.colors.white,
	padding: '1rem',
	flexWrap: 'wrap',
}))
